import iso from "src/assets/iso.json";
import {
  ChangeDetectorRef,
  Component,
  EventEmitter,
  Input,
  OnDestroy,
  OnInit,
  Output,
} from "@angular/core";
import { WebsocketService } from "src/app/core/services/websocket.service";
import {
  UntypedFormBuilder,
  UntypedFormControl,
  UntypedFormGroup,
  Validators,
} from "@angular/forms";
import { MiddlwareService } from "src/app/core/services/middleware.service";
import { ListMessageTemplate } from "src/app/core/services/outbound";

@Component({
  selector: "app-message-template-selector",
  templateUrl: "./message-template-selector.component.html",
  styleUrls: ["./message-template-selector.component.scss"],
  providers: [],
})

export class MessageTemplateSelectorComponent implements OnInit, OnDestroy {
  @Input() mode = "list";
  @Input() single = false;
  @Input() selectedTemplates = [];
  @Output() selectedNotifier = new EventEmitter<any>();
  @Output() cancelNotifier = new EventEmitter<boolean>(false);
  breadCrumbItems: Array<{}>;
  page: Array<any> = [];
  eop = false;
  pageSize = 25;
  currentPage = 0;
  monthNames = [
    "Jan",
    "Feb",
    "Mar",
    "Apr",
    "May",
    "June",
    "July",
    "Aug",
    "Sept",
    "Oct",
    "Nov",
    "Dec",
  ];
  payload = {};
  searchForm: UntypedFormGroup;
  submitted = false;
  dupe = false;
  criterionCount = 0;
  component_ref: any;
  search_message = "";
  loading = false;
  templateList: {};
  selectedTemplatesList = {};
  verifySubscription: any;
  listTemplatesSubscription: any;

  constructor(
    private ws: WebsocketService,
    private formBuilder: UntypedFormBuilder,
    private ref: ChangeDetectorRef,
    private mdw: MiddlwareService
  ) {}

  ngOnInit() {
    this.component_ref = this.mdw.makeRef(16);
    this.currentPage = 1;
    this.templateList = {};

    this.searchForm = this.formBuilder.group({
      member_id: new UntypedFormControl(null),
      search_value: new UntypedFormControl(null),
      status: new UntypedFormControl(""),
      role_id: new UntypedFormControl(""),
      date: new UntypedFormControl(null),
      search_type: new UntypedFormControl("name"),
    });

    this.listTemplatesSubscription = this.ws.listMessageTemplatesContainer$.subscribe((listTemplatesData) => {
      if (listTemplatesData && listTemplatesData.ref === this.component_ref) {
        this.loading = false;
        this.currentPage = listTemplatesData.page_number;
        if (listTemplatesData.data.length == 0 && this.currentPage == 1) {
          this.search_message = "No results matched your search criteria";
        } else {
          this.search_message = "";
        }

        listTemplatesData.data.forEach((template) => {
          template.created_date = new Date(template.created_date);
          template.created_date =
            template.created_date.getDate() +
            " " +
            this.monthNames[template.created_date.getMonth()] +
            ", " +
            template.created_date.getFullYear();
          this.templateList[String(template.id)] = template;
        });

        this.page = [];
        for (let i = 0; i < this.pageSize; i++) {
          if (
            Object.keys(this.templateList)[
              i + (this.currentPage - 1) * this.pageSize
            ]
          ) {
            this.page.push(
              this.templateList[
                Object.keys(this.templateList)[
                  i + (this.currentPage - 1) * this.pageSize
                ]
              ]
            );
          }
        }

        document
          .getElementById("pagination_back")
          .classList.remove("d-none");
        document
          .getElementById("pagination_back")
          .classList.add("enablePointer");
        document
          .getElementById("pagination_next")
          .classList.remove("d-none");
        document
          .getElementById("pagination_next")
          .classList.add("enablePointer");

        this.eop = false;
        if (listTemplatesData.eop) {
          this.eop = true;
          document
            .getElementById("pagination_next")
            .classList.add("d-none");
          document
            .getElementById("pagination_next")
            .classList.remove("enablePointer");
        } else {
          document
            .getElementById("pagination_next")
            .classList.remove("d-none");
          document
            .getElementById("pagination_next")
            .classList.add("enablePointer");
        }
        if (this.currentPage == 1) {
          document
            .getElementById("pagination_back")
            .classList.add("d-none");
          document
            .getElementById("pagination_back")
            .classList.remove("enablePointer");
        } else {
          document
            .getElementById("pagination_back")
            .classList.remove("d-none");
          document
            .getElementById("pagination_back")
            .classList.add("enablePointer");
        }
        if (this.currentPage == 1 && listTemplatesData.eop) {
          document
            .getElementById("showPageNumber")
            .classList.add("invisible");
        } else {
          document
            .getElementById("showPageNumber")
            .classList.remove("invisible");
        }
        this.ref.detectChanges();
      }
    });

    this.verifySubscription = this.ws.verifyContainer$.subscribe((verifyData) => {
      if (verifyData) {
        this.loading = true;
        this.ws.processMethod(new ListMessageTemplate(this.currentPage, this.pageSize, this.component_ref));
      }
    });

    // console.log(this.selectedTemplates);
    if (this.selectedTemplates && this.selectedTemplates.length > 0) {
      for (let i = 0; this.selectedTemplates.length > i; i++) {
        if(this.selectedTemplates[i] != null){
          this.selectedTemplatesList[this.selectedTemplates[i].id] = this.selectedTemplates[i];
        }
      }
    }
  }

  get f() {
    return this.searchForm.controls;
  }

  onSubmit() {
    this.submitted = true;
    if (this.searchForm.valid) {
    } else {
      return;
    }
  }

  botSearch() {
    let filter = this.f.search_value.value.toUpperCase();
    let type = this.f.search_type.value;
    let list: any = document.querySelectorAll("#bots-list");
    for (let i = 0; i < list.length; i++) {
      let el = list[i].querySelector(`#${type}`).getElementsByTagName("p")[0];
      let value = el.innerText;
      if (value.toLocaleUpperCase().indexOf(filter) > -1) {
        list[i].style.display = "";
      } else {
        list[i].style.display = "none";
      }
    }
  }

  selectUsers(data) {
    if (this.single) {
      if (this.selectedTemplatesList[data.id]) {
        delete this.selectedTemplatesList[data.id];
      } else {
        this.selectedTemplatesList = {};
        this.selectedTemplatesList[data.id] = data;
      }
    } else {
      if (this.selectedTemplatesList[data.id]) {
        delete this.selectedTemplatesList[data.id];
      } else {
        this.selectedTemplatesList[data.id] = data;
      }
    }
  }

  insertTemplate() {
    const selected = Object.values(this.selectedTemplatesList);
    this.selectedNotifier.emit(selected);
  }

  cancelEvent() {
    this.cancelNotifier.emit(true);
  }

  isObjEmpty() {
    return Object.keys(this.selectedTemplatesList).length === 0;
  }

  isSelected(id: string) {
    return this.selectedTemplatesList[id] ? true : false;
  }

  searchTypeChanged() {
    if (this.searchForm.value.search_type === "member_id") {
      this.searchForm
        .get("search_value")
        .setValidators([Validators.pattern(/^[0-9]*$/)]);
    } else {
      this.searchForm.get("search_value").clearValidators();
    }
    this.searchForm.get("search_value").updateValueAndValidity();
  }

  nextPage() {
    // console.log("request");
    this.payload["page_size"] = this.pageSize;
    this.payload["page_number"] = this.currentPage;
    this.payload["chat_id"] = localStorage.getItem("chat_id");
    this.payload["type"] = "BookingChannel";
    // this.ws.processMethod(
    //   new GetWorkflows(
    //     this.currentPage,
    //     this.component_ref,
    //     this.payload["workflow_id"],
    //     this.payload["name"],
    //     this.payload["created_date"]
    //   )
    // );
  }

  backPage() {
    if (this.currentPage != 1) {
      this.currentPage--;
      this.page = [];
      for (let i = 0; i < this.pageSize; i++) {
        if (
          Object.keys(this.templateList)[
            i + (this.currentPage - 1) * this.pageSize
          ]
        ) {
          this.page.push(
            this.templateList[
              Object.keys(this.templateList)[
                i + (this.currentPage - 1) * this.pageSize
              ]
            ]
          );
        }
      }
      if (this.currentPage == 1) {
        document.getElementById("pagination_back").classList.add("d-none");
        document
          .getElementById("pagination_back")
          .classList.remove("enablePointer");
      }
      if (
        this.currentPage <
        Object.keys(this.templateList).length / this.pageSize
      ) {
        document.getElementById("pagination_next").classList.remove("d-none");
        document
          .getElementById("pagination_next")
          .classList.add("enablePointer");
      }
    }
  }

  ngOnDestroy(): void {
    if (this.listTemplatesSubscription) {
      this.listTemplatesSubscription.unsubscribe();
    }
    if (this.verifySubscription) {
      this.verifySubscription.unsubscribe();
    }
  }
}
